module.exports = __webpack_public_path__ + "static/media/sostozoo.dc16a91e.png";